import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
  CButtonGroup,
  CCol,
  CFormCheck,
} from '@coreui/react'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import { isEmpty } from 'lodash'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import { AppContext } from 'src/views/context/app'
import Loading from 'react-fullscreen-loading'
import TemplateAccordion from '../templateAccordion'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'

const FitnessPackagesModal = ({ componentData, modifyData, onCancel }) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)
  const [title, setTitle] = useState('')
  const [isTripple, setIsTripple] = useState(true)
  const [cardAImageData, setCardAImageData] = useState([])
  const [cardBImageData, setCardBImageData] = useState([])
  const [cardCImageData, setCardCImageData] = useState([])
  const [cardDImageData, setCardDImageData] = useState([])
  const [cardEImageData, setCardEImageData] = useState([])
  const [errorData, setErrorData] = useState({})
  const [cardAData, setCardAData] = useState({
    image_s3key: '',
    heading: '',
    sub_heading: '',
    price_tag: '',
    button_text: '',
    description: '',
    link: {
      type: '',
      data: {},
    },
  })
  const [cardBData, setCardBData] = useState({
    image_s3key: '',
    heading: '',
    sub_heading: '',
    price_tag: '',
    button_text: '',
    description: '',
    link: {
      type: '',
      data: {},
    },
  })
  const [cardCData, setCardCData] = useState({
    image_s3key: '',
    heading: '',
    sub_heading: '',
    price_tag: '',
    button_text: '',
    description: '',
    link: {
      type: '',
      data: {},
    },
  })

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (
      isTripple &&
      (cardAData.image_s3key.trim().length === 0 ||
        cardBData.image_s3key.trim().length === 0 ||
        cardCData.image_s3key.trim().length === 0)
    ) {
      isFormValid = false
      temp.trippleImg = 'Upload Image!'
    }
    if (
      !isTripple &&
      (cardAData.image_s3key.trim().length === 0 || cardBData.image_s3key.trim().length === 0)
    ) {
      isFormValid = false
      temp.doubleImg = 'Upload Image!'
    }

    if (cardAData.link.type && !validateLink(cardAData.link).isValid) {
      isFormValid = false
      temp.cardALink = validateLink(cardAData.link).error
    }
    if (cardBData.link.type && !validateLink(cardBData.link).isValid) {
      isFormValid = false
      temp.cardBLink = validateLink(cardBData.link).error
    }
    if (isTripple && cardCData.link.type && !validateLink(cardCData.link).isValid) {
      isFormValid = false
      temp.cardCLink = validateLink(cardCData.link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let elementObj = {
      title: title,
      is_tripple: isTripple,
      items: isTripple
        ? [{ ...cardAData }, { ...cardBData }, { ...cardCData }]
        : [{ ...cardAData }, { ...cardBData }],
    }

    modifyData(componentData.id, elementObj)
  }

  useEffect(() => {
    let imgObj = {
      title: '',
      width: 520,
      height: 296,
      divheight: '5.7rem',
      divwidth: '9.3rem',
      setAssetId: (id) => {},
      titleDisabled: true,
      uploadIconflexRow: true,
      imagePaddingX: '6px',
      imagePaddingY: '6px',
      btnMarginTop: '4px',
    }
    let aImgUrl = ''
    let bImgUrl = ''
    let cImgUrl = ''
    let dImgUrl = ''
    let eImgUrl = ''
    if (!isEmpty(componentData?.data)) {
      setTitle(componentData?.data?.title)

      setIsTripple(componentData?.data?.is_tripple)
      let tempItemArr = componentData?.data?.items
      setCardAData(tempItemArr[0])
      setCardBData(tempItemArr[1])

      if (componentData?.data?.is_tripple) {
        setCardCData(tempItemArr[2])
        aImgUrl = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          tempItemArr[0]?.image_s3key,
        )
        bImgUrl = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          tempItemArr[1]?.image_s3key,
        )

        cImgUrl = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          tempItemArr[2]?.image_s3key,
        )
      } else {
        dImgUrl = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          tempItemArr[0]?.image_s3key,
        )
        eImgUrl = getThumbnail(
          userSessionObj.session_data.cf_domain_name,
          tempItemArr[1]?.image_s3key,
        )
      }
    }
    setCardAImageData([
      {
        ...imgObj,
        assetId: aImgUrl,
        imageUrl: aImgUrl,
        id: 'setCardAImageData',
        setImage: (obj) => {
          clearError('trippleImg')
          setCardAData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardAData((prev) => ({ ...prev, image_s3key: '' }))
        },
      },
    ])
    setCardBImageData([
      {
        ...imgObj,
        id: 'setCardBImageData',
        assetId: bImgUrl,
        imageUrl: bImgUrl,
        setImage: (obj) => {
          clearError('trippleImg')
          setCardBData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardBData((prev) => ({ ...prev, image_s3key: '' }))
        },
      },
    ])
    setCardCImageData([
      {
        ...imgObj,
        id: 'setCardCImageData',
        assetId: cImgUrl,
        imageUrl: cImgUrl,
        setImage: (obj) => {
          clearError('trippleImg')
          setCardCData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardCData((prev) => ({ ...prev, image_s3key: '' }))
        },
      },
    ])
    setCardDImageData([
      {
        ...imgObj,
        id: 'setCardDImageData',
        assetId: dImgUrl,
        imageUrl: dImgUrl,
        setImage: (obj) => {
          clearError('doubleImg')
          setCardAData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardAData((prev) => ({ ...prev, image_s3key: '' }))
        },
      },
    ])
    setCardEImageData([
      {
        ...imgObj,
        id: 'setCardEImageData',
        assetId: eImgUrl,
        imageUrl: eImgUrl,
        setImage: (obj) => {
          clearError('doubleImg')
          setCardBData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardBData((prev) => ({ ...prev, image_s3key: '' }))
        },
      },
    ])
  }, [])

  const onCardTypeChange = (event) => {
    const { value } = event.target
    let newObj = {
      image_s3key: '',
      heading: '',
      sub_heading: '',
      price_tag: '',
      button_text: '',
      description: '',
      link: {
        type: '',
        data: {},
      },
    }
    setCardAData(newObj)
    setCardBData(newObj)
    setCardCData(newObj)
    clearError('trippleImg')
    clearError('doubleImg')
    clearError('cardALink')
    clearError('cardBLink')
    clearError('cardCLink')

    let imgObj = {
      title: '',
      width: 520,
      height: 296,
      divheight: '5.7rem',
      divwidth: '9.3rem',
      assetId: '',
      imageUrl: '',
      setAssetId: (id) => {},
      titleDisabled: true,
      uploadIconflexRow: true,
      imagePaddingX: '6px',
      imagePaddingY: '6px',
      btnMarginTop: '2px',
    }

    setCardAImageData([
      {
        ...imgObj,
        id: 'setCardAImageData',
        setImage: (obj) => {
          clearError('trippleImg')
          setCardAData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardAData((prev) => ({ ...prev, image_s3key: '' }))
        },
      },
    ])
    setCardBImageData([
      {
        ...imgObj,
        id: 'setCardBImageData',
        setImage: (obj) => {
          clearError('trippleImg')
          setCardBData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardBData((prev) => ({ ...prev, image_s3key: '' }))
        },
      },
    ])
    setCardCImageData([
      {
        ...imgObj,
        id: 'setCardCImageData',
        setImage: (obj) => {
          clearError('trippleImg')
          setCardCData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardCData((prev) => ({ ...prev, image_s3key: '' }))
        },
      },
    ])
    setCardDImageData([
      {
        ...imgObj,
        id: 'setCardDImageData',
        setImage: (obj) => {
          clearError('doubleImg')
          setCardAData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardAData((prev) => ({ ...prev, image_s3key: '' }))
        },
      },
    ])
    setCardEImageData([
      {
        ...imgObj,
        id: 'setCardEImageData',
        setImage: (obj) => {
          clearError('doubleImg')
          setCardBData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardBData((prev) => ({ ...prev, image_s3key: '' }))
        },
      },
    ])

    value === 'tripple' ? setIsTripple(true) : setIsTripple(false)
  }
  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }
  let tripleAccordionItems = [
    {
      title: 'Add text to Image-A',
      description: 'Specify elements under the card which contain Image-A.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="mt-1 d-flex justify-content-between">
            <div className="w-50 mr-3">
              <h6 style={{ fontSize: '13px' }}>Heading</h6>
              <CustomDescriptionBox
                limit={60}
                rows={1}
                value={cardAData.heading}
                onChange={(value) => setCardAData((prev) => ({ ...prev, heading: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
            <div className="w-50 ml-3">
              <h6 style={{ fontSize: '13px' }}>Sub-Heading</h6>
              <CustomDescriptionBox
                limit={48}
                rows={1}
                value={cardAData.sub_heading}
                onChange={(value) => setCardAData((prev) => ({ ...prev, sub_heading: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Paragraph</h6>
            <CustomDescriptionBox
              limit={260}
              rows={3}
              value={cardAData.description}
              onChange={(value) => setCardAData((prev) => ({ ...prev, description: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1 d-flex justify-content-between">
            <div className="w-50 mr-3">
              <h6 style={{ fontSize: '13px' }}>Price Tag</h6>
              <CustomDescriptionBox
                limit={22}
                rows={1}
                value={cardAData.price_tag}
                onChange={(value) => setCardAData((prev) => ({ ...prev, price_tag: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
            <div className="w-50 ml-3">
              <h6 style={{ fontSize: '13px' }}>Text on Button</h6>
              <CustomDescriptionBox
                limit={14}
                rows={1}
                value={cardAData.button_text}
                onChange={(value) => setCardAData((prev) => ({ ...prev, button_text: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
          </div>
          <div className="mt-2">
            <AttachLink
              linkData={cardAData.link}
              id={'cardAData'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('cardALink')
                setCardAData((prev) => ({ ...prev, link: value }))
              }}
              selectorWidth={'78%'}
            />
            <div className="message-text error-message">
              <p>{errorData.cardALink}</p>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add text to Image-B',
      description: 'Specify elements under the card which contain Image-B.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="mt-1 d-flex justify-content-between">
            <div className="w-50 mr-3">
              <h6 style={{ fontSize: '13px' }}>Heading</h6>
              <CustomDescriptionBox
                limit={60}
                rows={1}
                value={cardBData.heading}
                onChange={(value) => setCardBData((prev) => ({ ...prev, heading: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
            <div className="w-50 ml-3">
              <h6 style={{ fontSize: '13px' }}>Sub-Heading</h6>
              <CustomDescriptionBox
                limit={48}
                rows={1}
                value={cardBData.sub_heading}
                onChange={(value) => setCardBData((prev) => ({ ...prev, sub_heading: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Paragraph</h6>
            <CustomDescriptionBox
              limit={260}
              rows={3}
              value={cardBData.description}
              onChange={(value) => setCardBData((prev) => ({ ...prev, description: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1 d-flex justify-content-between">
            <div className="w-50 mr-3">
              <h6 style={{ fontSize: '13px' }}>Price Tag</h6>
              <CustomDescriptionBox
                limit={22}
                rows={1}
                value={cardBData.price_tag}
                onChange={(value) => setCardBData((prev) => ({ ...prev, price_tag: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
            <div className="w-50 ml-3">
              <h6 style={{ fontSize: '13px' }}>Text on Button</h6>
              <CustomDescriptionBox
                limit={14}
                rows={1}
                value={cardBData.button_text}
                onChange={(value) => setCardBData((prev) => ({ ...prev, button_text: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
          </div>
          <div className="mt-2">
            <AttachLink
              linkData={cardBData.link}
              id={'cardBData'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('cardBLink')
                setCardBData((prev) => ({ ...prev, link: value }))
              }}
              selectorWidth={'78%'}
            />
            <div className="message-text error-message">
              <p>{errorData.cardBLink}</p>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add text to Image-C',
      description: 'Specify elements under the card which contain Image-C.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="mt-1 d-flex justify-content-between">
            <div className="w-50 mr-3">
              <h6 style={{ fontSize: '13px' }}>Heading</h6>
              <CustomDescriptionBox
                limit={60}
                rows={1}
                value={cardCData.heading}
                onChange={(value) => setCardCData((prev) => ({ ...prev, heading: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
            <div className="w-50 ml-3">
              <h6 style={{ fontSize: '13px' }}>Sub-Heading</h6>
              <CustomDescriptionBox
                limit={48}
                rows={1}
                value={cardCData.sub_heading}
                onChange={(value) => setCardCData((prev) => ({ ...prev, sub_heading: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Paragraph</h6>
            <CustomDescriptionBox
              limit={260}
              rows={3}
              value={cardCData.description}
              onChange={(value) => setCardCData((prev) => ({ ...prev, description: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1 d-flex justify-content-between">
            <div className="w-50 mr-3">
              <h6 style={{ fontSize: '13px' }}>Price Tag</h6>
              <CustomDescriptionBox
                limit={22}
                rows={1}
                value={cardCData.price_tag}
                onChange={(value) => setCardCData((prev) => ({ ...prev, price_tag: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
            <div className="w-50 ml-3">
              <h6 style={{ fontSize: '13px' }}>Text on Button</h6>
              <CustomDescriptionBox
                limit={14}
                rows={1}
                value={cardCData.button_text}
                onChange={(value) => setCardCData((prev) => ({ ...prev, button_text: value }))}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
          </div>
          <div className="mt-2">
            <AttachLink
              linkData={cardCData.link}
              id={'cardCData'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('cardCLink')
                setCardCData((prev) => ({ ...prev, link: value }))
              }}
              selectorWidth={'78%'}
            />
            <div className="message-text error-message">
              <p>{errorData.cardCLink}</p>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
  ]

  let doubleAccordionItems = tripleAccordionItems.filter((info, index) => index !== 2)
  return (
    <CModal size="lg" className="fitness-package-modal" visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalHeader
        style={{ borderBottom: 0 }}
        className="d-flex flex-column justify-content-center mt-3 px-5"
      >
        <p style={{ fontSize: '1.2rem' }}>
          <b style={{ fontWeight: '500' }}>{`'Our Package' Card Editor`}</b>
        </p>
      </CModalHeader>
      <CModalBody style={{ height: '70vh' }} className=" static-scrollbar-class px-5 ">
        <div className="w-100">
          <h6 style={{ fontSize: '14px' }}>Component Title</h6>
          <CustomDescriptionBox
            limit={40}
            rows={1}
            value={title}
            onChange={(value) => setTitle(value)}
            style={{ fontSize: '12px' }}
            limitFontSize={'11px'}
            useFormInput={true}
          />
        </div>
        <CRow className="">
          <CCol>
            <h6 className="font-13px">
              Select the Card segment style <span style={{ color: 'red' }}>*</span>
            </h6>
            <CButtonGroup
              id="group1"
              role="group"
              aria-label="Basic checkbox toggle button group"
              style={{ fontSize: '12px' }}
              className="w-100"
            >
              <div className="mt-2 d-flex justify-content-between w-100">
                <div className="d-flex flex-column justify-content-start">
                  <CFormCheck
                    type="radio"
                    id="tripple"
                    label={
                      <>
                        <span>Set of Three cards </span>
                        <span style={{ fontSize: '10px', color: '#707070' }}>
                          ( Image: 520px X 296px )
                        </span>
                      </>
                    }
                    value="tripple"
                    checked={isTripple}
                    onChange={(e) => onCardTypeChange(e)}
                  />
                  <div
                    className="d-flex justify-content-center align-items-center p-2"
                    style={{ background: '#dbdbdb' }}
                  >
                    <div className=" text-center">
                      Image A
                      {cardAImageData && (
                        <ImageUploader data={cardAImageData} isDisabled={!isTripple} />
                      )}
                    </div>
                    <div className="mx-2 text-center">
                      Image B
                      {cardBImageData && (
                        <ImageUploader data={cardBImageData} isDisabled={!isTripple} />
                      )}
                    </div>
                    <div className=" text-center">
                      Image C
                      {cardCImageData && (
                        <ImageUploader data={cardCImageData} isDisabled={!isTripple} />
                      )}
                    </div>
                  </div>
                  <div className="message-text error-message text-center">
                    <p>{errorData.trippleImg}</p>
                  </div>
                </div>
                <div className="d-flex flex-column justify-content-start">
                  <CFormCheck
                    type="radio"
                    id="double"
                    label={
                      <>
                        <span>Set of Two cards </span>
                        <span style={{ fontSize: '10px', color: '#707070' }}>
                          ( Image: 520px X 296px )
                        </span>
                      </>
                    }
                    value="double"
                    checked={!isTripple}
                    onChange={(e) => onCardTypeChange(e)}
                  />
                  <div
                    className="d-flex justify-content-center align-items-center p-2"
                    style={{ background: '#dbdbdb' }}
                  >
                    <div className=" text-center">
                      Image A
                      {cardDImageData && (
                        <ImageUploader data={cardDImageData} isDisabled={isTripple} />
                      )}
                    </div>
                    <div className="ml-2 text-center">
                      Image B
                      {cardEImageData && (
                        <ImageUploader data={cardEImageData} isDisabled={isTripple} />
                      )}
                    </div>
                  </div>
                  <div className="message-text error-message text-center">
                    <p>{errorData.doubleImg}</p>
                  </div>
                </div>
              </div>
            </CButtonGroup>
          </CCol>
        </CRow>
        <CRow>
          <TemplateAccordion
            items={isTripple ? tripleAccordionItems : doubleAccordionItems}
            styles={''}
          />
        </CRow>
      </CModalBody>
      <CModalFooter style={{ borderTop: 0 }} className=" px-5">
        <div className="pb-2">
          <CButton
            style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
            className="mx-4 bg-white rounded-1 btn-focus-none"
            onClick={onCancel}
          >
            Cancel
          </CButton>
          <CButton
            style={{ fontSize: '1.1rem' }}
            className=" bg-black rounded-1 btn-focus-none px-3"
            onClick={handleSave}
          >
            Save
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  )
}

export default FitnessPackagesModal
